import * as yup from "yup";
import { validationSchemas } from "./data";
export const productOptionCategorySchema = yup.object().shape({
  productCategory: validationSchemas.name,
  unit: validationSchemas.name,
  selectType: validationSchemas.numberSelect,
});
